import React from "react";

const DotSeparator = () => (
	<span style={{ margin: "0 5px" }} aria-hidden="true">
		·
	</span>
);

export default DotSeparator;
